let getters = {

  otpError (state) {
    return state.otpError
  },
  loginError (state) {
    return state.loginError
  },
  sessionId (state) {
    return state.sessionId
  },
  user (state) {

    return state.user
  },
  userType (state) {
    return state.userType
  },
  loggedIn (state) {
    return state.loggedIn
  },
  mobile (state) {
    return state.mobile
  },
  isV2User (state) {
    return state.user && state.user.version === 'epaylaterv2'
  }

}

export default getters



// WEBPACK FOOTER //
// ./src/store/login/getters.js